import {useGetAndSet} from "./useGetAndSet";
import {createSetWorkTypeDataAction} from "../actions/dataActions";


export const useWorkTypeData = (params, dataFresh) => {
    return useGetAndSet("worktype", params, createSetWorkTypeDataAction, dataFresh);
}